/**
 * Cột điểm trên bảng tốt nghiệp (phản hồi trung tâm, 28/10/2026).
 *
 * - Luật và Mô phỏng: một cột mỗi môn, gõ vào L1. Ô L2 vẫn còn trong dữ liệu
 *   và đồng bộ GetFly; dòng cũ nào đã có L2 thì cột hiện L2 kèm cờ để không
 *   giấu mất điểm thi lại.
 * - TB thực hành - KTKH: backend tự tính = (Chữ chi + Sa hình + Đường) / 30
 *   khi đủ ba môn, nên ở đây chỉ để xem.
 */
export const O_DIEM_BANG = [
  { key: 'lyThuyetL1', l2: 'lyThuyetL2', nhan: 'Luật', choGo: true },
  { key: 'moPhongL1', l2: 'moPhongL2', nhan: 'Mô phỏng', choGo: true },
  { key: 'chuChi', nhan: 'Chữ chi', choGo: true },
  { key: 'hinh', nhan: 'Sa hình', choGo: true },
  { key: 'duong', nhan: 'Đường', choGo: true },
  { key: 'diemTbThucHanhKtkh', nhan: 'TB thực hành - KTKH', choGo: false },
];

const coSo = (o) => !!o && o.value !== null && o.value !== undefined;

/** Giá trị hiện trong ô: L2 nếu dòng đã có L2, không thì ô chính. */
export function oHienThi(diem = {}, cot) {
  const l2 = cot.l2 ? diem[cot.l2] : null;
  const o = coSo(l2) ? l2 : (diem[cot.key] || {});
  return { value: coSo(o) ? o.value : null, nguon: o.nguon || '', laL2: coSo(l2) };
}
